import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('pages.RequestList.QBooksJournalEntryFooter', {
    debitTitle: 'Debit',
    creditTitle: 'Credit',
    totalTitle: 'Total',
    subtotalTitle: 'Subtotal',
    taxInclusiveText: 'Amounts are Tax Inclusive',
    taxExclusiveText: 'Amounts are Tax Exclusive',
});
